import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import { Keys, locale } from 'src/i18n';
import { MyPDDRecord } from './types';
import styles from './index.module.scss';

const renderValue = (value: string | number) => value || '-';

function DocumentRecord({ record }: { record: MyPDDRecord }) {
  const isCritical = record.documentCategory.toUpperCase() === 'CRITICAL';

  return (
    <div className={styles.myPDD__record}>
      <div className={styles.myPDD__recordMain}>
        <Text semiBold classNames={styles.myPDD__docName}>
          {renderValue(record.documentName)}
        </Text>
        <Tag
          label={String(renderValue(record.documentCategory))}
          className={`${styles.myPDD__categoryTag} ${
            isCritical
              ? styles.myPDD__categoryTagCritical
              : styles.myPDD__categoryTagDefault
          }`}
        />
      </div>

      <div className={styles.myPDD__recordFields}>
        <Text type="subText" classNames={styles.myPDD__docDescription}>
          {renderValue(record.documentDescription)}
        </Text>
        <div className={styles.myPDD__field}>
          <Text type="subText" classNames={styles.myPDD__fieldLabel}>
            {locale(Keys.ABC_PDD_DEFERRED_DATE)}
          </Text>
          <Text semiBold classNames={styles.myPDD__fieldValue}>
            {renderValue(record.deferredDate)}
          </Text>
        </div>
      </div>

      <Text semiBold classNames={styles.myPDD__status}>
        {renderValue(record.documentStatus)}
      </Text>
    </div>
  );
}

export default DocumentRecord;
